import {
  FormFieldType,
  FormQuestion,
} from "../../events-screen/event-page-models/form-question";

export const receiptPageSubmitReceiptModalFormObject: FormQuestion[] = [
  {
    fieldName: "transActionReferenceNumber",
    placeHolder: "",
    selectItems: [],
    label: "מספר אסמכתא",
    order: 0,
    isRequired: true,
    fieldType: FormFieldType.Number,
    customIcon: "users/view-receipt.svg",
    value: "",
  },
  {
    fieldName: "depositDate",
    placeHolder: "",
    label: "תאריך הפקדה",
    order: 0,
    isRequired: true,
    fieldType: FormFieldType.Date,
    value: "",
  },
  {
    fieldName: "depositAmount",
    placeHolder: "",
    label: "סכום ההפקדה",
    order: 0,
    isRequired: true,
    fieldType: FormFieldType.Number,
    customIcon: "shequel-sign.svg",
    value: "",
  },
  {
    fieldName: "comments",
    placeHolder: "",
    label: "הערות",
    order: 0,
    isRequired: false,
    fieldType: FormFieldType.LongText,
    value: "",
  },
];



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-submit-receipt-modal/receipt-page-submit-receipt-modal-form-object.ts